import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { GenericService } from 'src/app/generic.service';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styles: [
  ]
})
export class DeleteDialogComponent implements OnInit {

  data: any;
  allowDelete = true;

  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private service: GenericService) {
    this.data = ddata;
    if (this.data.section === 2) {
      this.service.getData('InvoiceYear/GetMultiListBySection/' + this.data.yfid + '/' + this.data.section).then(response => {
        if (response.list.length > 1) {
          this.allowDelete = true;
        } else {
          this.allowDelete = false;
        }
      });
    } else {
      this.allowDelete = true;
    }

  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  delete(): void {
    this.dialogRef.close(true);
  }
}
